import { useEffect } from 'react';
import type { ServerEvent } from '../../shared/types';
import { useChat } from '../state';

export function useSocket() {
  useEffect(() => {
    let socket: WebSocket | null = null;
    let closed = false;
    let attempt = 0;

    const connect = () => {
      const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
      socket = new WebSocket(`${protocol}://${location.host}/ws`);
      socket.onopen = () => {
        attempt = 0;
        useChat.getState().setConnected(true);
      };
      socket.onmessage = (message) => {
        try {
          useChat.getState().applyEvent(JSON.parse(message.data as string) as ServerEvent);
        } catch {
          // ignore malformed frames
        }
      };
      socket.onclose = () => {
        useChat.getState().setConnected(false);
        if (closed) return;
        attempt += 1;
        setTimeout(connect, Math.min(500 * 2 ** attempt, 8000));
      };
    };

    connect();
    return () => {
      closed = true;
      socket?.close();
    };
  }, []);
}
